import { type FanShopProductVariant } from '@capsicum/common';
import { useMemo } from 'react';

import { useProductsQueries } from '../data-access';

import { useCategories } from './useCategories';

export const useCarouselProducts = (partnerId: string) => {
	const { getProductCategoriesBy, parentCategories } = useCategories([partnerId]);
	const parentCategoryIds = (parentCategories?.map(c => c.id).filter(Boolean) as Array<string>) ?? [];
	const productCategories = getProductCategoriesBy(c => parentCategoryIds.some(id => id === c?.parentCategory?.id));
	const ids = new Set(productCategories.map(c => c.id).filter(Boolean) as Array<string>);

	const { data, isLoading, refetch } = useProductsQueries([partnerId], Array.from(ids), 5);
	const products: Array<FanShopProductVariant> = useMemo(
		() =>
			(data &&
				data?.pages.flatMap(page => {
					return page?.data || [];
				})) ??
			[],
		[data]
	);

	return {
		isLoading,
		products,
		refetchProducts: refetch
	};
};
